import usePagination from "~/hooks/usePagination";
import useCurrentUser from "~/hooks/user/useCurrentUser";
import useUrlParams from "~/hooks/useUrlParams";
import type { PaginationUrlParams } from "~/types";
import { whereToAnd } from "~/util/payload";

interface Params {
  depth?: number;
  filterOrganization?: boolean;
}

const useGetPaginatedProperties = ({ depth, filterOrganization }: Params) => {
  const { params: urlParams } = useUrlParams();

  const {
    data: { organization },
    isLoading: userLoading,
  } = useCurrentUser();

  const organizationId = organization?.id;

  const thisParamSet = urlParams?.["properties"] as PaginationUrlParams;

  const where: Record<string, any> = thisParamSet?.where || {};

  const archived = thisParamSet?.where?.archived;

  delete where.archived;

  if (filterOrganization && organizationId) {
    where.organization = {
      equals: organizationId,
    };
  }

  return usePagination({
    archived,
    collection: "properties",
    where: whereToAnd(where),
    sort: thisParamSet?.sort,
    page: thisParamSet?.page,
    limit: thisParamSet?.limit,
    serialLoading: userLoading,
    depth,
  });
};

export default useGetPaginatedProperties;
